import { AutoStack, FormikGraphQLDatePicker } from 'components'
import { DayPickerStrings, onFormatDate } from 'components/DatePickers/helpers'
import { FieldProps } from 'formik'
import { AuthorizedField as Field } from 'forms/AuthorizedField'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import * as model from 'model'
import { Proving } from 'model'
import { DayOfWeek, DefaultButton, Label } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { ParticipantListItem } from 'views/ParticipantViews'
import { ResourceOfficeBookingListItem } from 'views/ResourceBookingsView'
import * as Yup from 'yup'

export type ProvingDetailsTimespanFormValues = Proving
export class ProvingDetailsTimespanFormSchema {
  constructor(provingDateFrom: string, provingDateTo: string) {
    const minDate = new Date(provingDateFrom)
    minDate.setDate(minDate.getDate() - 1)
    return Yup.object().shape({
      dateFrom: Yup.date().required(),
      dateTo: Yup.date()
        .required()
        .when(
          'dateFrom',
          (dateFrom: any, schema: any) => dateFrom && schema.min(dateFrom)
        ),
    })
  }
}

export const ProvingDetailsTimespanForm: React.FC<{
  proving: Partial<model.Proving>
  notification?: boolean
  changeNotification?: boolean
  participant?: Partial<ParticipantListItem>
  resource?: Partial<ResourceOfficeBookingListItem>
  wizard?: boolean
}> = ({
  proving,
  notification,
  changeNotification,
  participant,
  resource,
  wizard,
}) => {
  const { t } = useTranslation()

  // const validateDateFrom = () => {
  //   if (participant) {
  //     return new Date(participant.provingDateFrom as any)
  //   } else if (resource) {
  //     return new Date(resource.provingDateFrom as any)
  //   } else if (proving) {
  //     return new Date(proving.dateFrom)
  //   } else {
  //     return false
  //   }
  // }

  // const validateDateTo = () => {
  //   if (participant) {
  //     return new Date(participant.provingDateTo as any)
  //   } else if (resource) {
  //     return new Date(resource.provingDateTo as any)
  //   } else if (proving) {
  //     return new Date(proving.dateTo)
  //   } else {
  //     return false
  //   }
  // }

  return (
    <AutoStack tokens={{ childrenGap: 12 }}>
      <FormStack>
        {notification && (
          <FieldStack>
            <Label>{t('field.timespan.multiSelectNotification')}</Label>
          </FieldStack>
        )}
        {changeNotification && (
          <FieldStack>
            <Label>{t('field.timespan.changeNotification')}</Label>
          </FieldStack>
        )}
        {wizard && (
          <FieldStack>
            <Label>{t('field.timespan.resetToProvingDate')}</Label>
          </FieldStack>
        )}
        <Label required={true}>{t('field.timespan.label')}</Label>
        <FieldStack horizontal={true}>
          <FieldStackItem
            name="dateFrom"
            label={t('field.dateFrom.label')}
            isRequired={true}
            component={FormikGraphQLDatePicker}
            // minDate={validateDateFrom()}
            // maxDate={validateDateTo()}
            firstDayOfWeek={DayOfWeek.Monday}
            strings={DayPickerStrings}
            showWeekNumbers={true}
            formatDate={onFormatDate}
            initialPickerDate={new Date(proving.dateFrom)}
          />
          <FieldStackItem
            name="dateTo"
            label={t('field.dateTo.label')}
            isRequired={true}
            component={FormikGraphQLDatePicker}
            // minDate={validateDateFrom()}
            // maxDate={validateDateTo()}
            firstDayOfWeek={DayOfWeek.Monday}
            strings={DayPickerStrings}
            showWeekNumbers={true}
            formatDate={onFormatDate}
            today={new Date(proving.dateTo)}
            initialPickerDate={new Date(proving.dateFrom)}
          />
        </FieldStack>
      </FormStack>
      <Field
        render={(fieldProps: FieldProps<any>) => (
          <DefaultButton
            text={t('field.resetDate.label')}
            onClick={() => {
              fieldProps.form.setFieldValue(
                'dateFrom',
                (proving && proving.dateFrom) ||
                  (participant && participant.provingDateFrom) ||
                  (resource && resource.provingDateFrom)
              )
              fieldProps.form.setFieldValue(
                'dateTo',
                (proving && proving.dateTo) ||
                  (participant && participant.provingDateTo) ||
                  (resource && resource.provingDateTo)
              )
            }}
          />
        )}
      />
    </AutoStack>
  )
}
